import {nc2Service} from './nc2service'
import { handleInfoNc2Redux } from '.';

export const script_nc2 = (function ()
{

const { connection_platform } = require("../services/api")

function onScreenView(json,ramal,dispatch)
{
    var campos      = json.prospect.projeto.telaProjeto;
    var infos       = json.prospect.telaProspect;
    var URL = connection_platform.nc2_url;
    var TEMP = connection_platform.nc2_url;

    var tamInfos    = Object.keys(infos).length;
    var cont        = 0;
    var params      = '';
    var nomecampo = '';


    for(let i=0; i<tamInfos; i++){
        let valor =  'campo'+[i+1];
        if(infos[valor] !== null && infos[valor] !== undefined){
                cont++;
        }
    }

    var PARAMVISIBLEDETAILS = [
        'Código do Cliente: '+json.prospect.telaProspect.campo1,
        'Campanha: '+json.prospect.campanha.descricao,
        'Prospect: '+json.prospect.nome
    ]

    dispatch(handleInfoNc2Redux(PARAMVISIBLEDETAILS));

    try{


        for(let i=0; i<cont; i++){
            let valor =  'campo'+[i+1];
            if(campos[valor] !== "" && campos[valor] !== null){
                var str = campos[valor];
                str = str.replace(/[ÀÁÂÃÄÅ]/g,"A");
                str = str.replace(/[àáâãäå]/g,"a");
                str = str.replace(/[ÈÉÊË]/g,"E");
                

                URL = URL.replace('${'+str.trim()+'}', infos[valor])
                // params = params+'&'+campos[valor]+'='+infos[valor]
            }
            //retirar acentuacao
        }
    
    
    
        // if(connection_platform.nc2_integration)
        //     nc2Service.nc2AlteraStatus(ramal,'1')

        if(URL!==TEMP){
            window.open(`${URL}`, '_blank')
        }

    } catch(e){

        console.log("LOG NC2-IMSCAMP NÂO ACHOU O CAMPO")

    }

}
var wnc2 = {
    onScreenView: onScreenView,
};

return wnc2;
})();
window.script_nc2 = script_nc2;

export default script_nc2;
